import { Outlet, useNavigate } from "react-router-dom";
import { createContext, useEffect, useState } from "react";
import NavbarLeft from "./components/navigation/NavbarLeft";
import NavbarTop from "./components/navigation/NavbarTop";
import useAxios from "axios-hooks";
import { log } from "console";
import { BusinessResDto } from "./api/Api";

export const UserContext = createContext({} as any);

function App() {
  const navigate = useNavigate();

  const [titleComponent, setTitleComponent] = useState(undefined as any);

  const [isCollapsed, setIsCollapsed] = useState(() => {
    let collapsed = JSON.parse(localStorage.getItem("isCollapsed") as string)
      ? true
      : false;
    return collapsed;
  });

  const [
    { data: user, loading: userLoading, error: userError },
    getAuthenticatedUser,
  ] = useAxios(
    {
      url: "/auth/user",
    },
    { manual: true }
  );

  const [
    { data: business, loading: businessLoading, error: businessError },
    getBusiness,
  ] = useAxios<BusinessResDto>(`/businesses/me`);

  useEffect(() => {
    getAuthenticatedUser()
      .then((user) => {
        getBusiness()
          .then((business) => {})
          .catch((error) => {});

        // getSubscription()
        //   .then((subscription) => {
        //     //businessInfo?.data?.subscription.latest_invoice.payment_intent.status
        //     const latestInvoice = subscription?.data?.latest_invoice
        //     const paymentIntent = latestInvoice.payment_intent
        //     if(!subscription?.data) {
        //       navigate("/subscription/init");
        //     }
        //     if(!latestInvoice.paid && latestInvoice.billing_reason === "subscription_create") {
        //       return navigate("/subscription/init");
        //     }
        //     if(!latestInvoice.paid && latestInvoice.billing_reason === "subscription_update") {
        //       return navigate("/account/subscription");
        //     }
        //     if(!latestInvoice.paid && latestInvoice.billing_reason === "subscription_cycle") {
        //       return navigate("/account/subscription");
        //     }
        //   })
        //   .catch((error) => {
        //     navigate("/subscription/init");
        //   });
        // getSubscription();
      })
      .catch((error) => {
        navigate("/auth/login");
      });
  }, []);

  if (!user) {
    return (
      <div className="flex items-center justify-center h-screen w-screen">
        <div className="loading loading-spinner"></div>
      </div>
    );
  }

  return (
    <>
      {["Subscription is not active!", "Subscription has expired!"].includes(
        businessError?.response?.data?.message
      ) && (
        <div className=" bg-error text-sm p-4">
          <div className="text-lg font-bold ">
            {businessError?.response?.data?.message}
          </div>
          <div className="text-xs">
            To regain access to all features and services, please reach out to
            the Socora administrators. They can help you resolve any issues
            related to billing, expiration, or account status. If you believe
            this is a mistake, don't hesitate to get in touch for further
            assistance.
          </div>
        </div>
      )}
      <div className="flex h-screen">
        <div
          className={`${
            !isCollapsed ? "w-[15%]" : "w-[4.2%]"
          }  bg-base-200 transition-[width]  border-r  dark:border-white/10 border-black/5 shadow-xl`}
        >
          <UserContext.Provider value={user}>
            <NavbarLeft
              isCollapsed={isCollapsed}
              onCollapseChange={(collapsed: boolean) => {
                setIsCollapsed(collapsed);
                localStorage.setItem("isCollapsed", JSON.stringify(collapsed));
              }}
            ></NavbarLeft>
          </UserContext.Provider>
        </div>
        <div
          className={` ${
            !isCollapsed ? "w-[85%]" : "w-full"
          }  overflow-scroll transition-[width]`}
        >
          <UserContext.Provider value={user}>
            <NavbarTop titleComponent={titleComponent}></NavbarTop>
            <div>
              <Outlet context={{ setTitleComponent }}></Outlet>
            </div>
          </UserContext.Provider>
        </div>
      </div>
    </>
  );
}

export default App;
